import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { ADMIN_API_BASE_URL } from "../Auth/Api";
import Base from "../admin_components/Admin_Base";

export default function AddThirtyPercentForCustomer() {
  const [areas, setAreas] = useState([]);
  const [customersList, setCustomersList] = useState([]);
  const [loading, setLoading] = useState(true);

  const [formData, setFormData] = useState({
    customerId: "",
    areaId: "",
    amount: "",
    amountPaidTillNow: "",
    remainingThirtyPercentAmount: "",
    paymentDate: "",
    eligibleForPlot: false,
    txnId: "",
    status: "FAILED",
  });

  const token = localStorage.getItem("authToken");

  useEffect(() => {
    fetchAreas();
    fetchCustomerList();
  }, []);

  const fetchAreas = async () => {
    try {
      if (!token) {
        Swal.fire("Error", "You are not authenticated. Please log in.", "error");
        return;
      }

      const response = await fetch(`${ADMIN_API_BASE_URL}/main/admin/areas`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        Swal.fire("API Error", `Error ${response.status}: ${response.statusText}`, "error");
        return;
      }

      const data = await response.json();
      setAreas(Array.isArray(data) ? data : []);
    } catch (error) {
      Swal.fire("Error", "Something went wrong while fetching areas.", "error");
    } finally {
      setLoading(false);
    }
  };

  const fetchCustomerList = () => {
    axios
      .get(`${ADMIN_API_BASE_URL}/main/admin/list-customers`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setCustomersList(Array.isArray(response.data) ? response.data : []);
      })
      .catch((error) => {
        console.error("Error fetching customers:", error);
        setCustomersList([]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        `${ADMIN_API_BASE_URL}/main/admin/add-thirty-percent`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      Swal.fire("Success", "Transaction added successfully!", "success");

      setFormData({
        customerId: "",
        areaId: "",
        amount: "",
        amountPaidTillNow: "",
        remainingThirtyPercentAmount: "",
        paymentDate: "",
        isEligibleForPlot: false,
        txnId: "",
        status: "FAILED",
      });
    } catch (error) {
      console.error("Error adding transaction:", error);
      Swal.fire("Error", "Failed to add transaction", "error");
    }
  };

  return (
    <Base>
    <div className="container mt-5 pt-5 d-flex justify-content-center">
      <div className=" shadow p-4" style={{ width: "80%" }}>
        <h3 className="mb-4">Add 30% Transaction</h3>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">Customer</label>
            <select
              className="form-select"
              name="customerId"
              value={formData.customerId}
              onChange={handleChange}
              required
            >
              <option value="">Select Customer</option>
              {customersList.map((customer) => (
                <option key={customer.customerId} value={customer.customerId}>
                  {customer.customerName}
                </option>
              ))}
            </select>
          </div>

          <div className="mb-3">
            <label className="form-label">Area</label>
            <select
              className="form-select"
              name="areaId"
              value={formData.areaId}
              onChange={handleChange}
              required
            >
              <option value="">Select Area</option>
              {areas.map((area) => (
                <option key={area.id} value={area.id}>
                  {area.area}
                </option>
              ))}
            </select>
          </div>

          <div className="mb-3">
            <label className="form-label">Amount</label>
            <input
              type="number"
              className="form-control"
              name="amount"
              value={formData.amount}
              onChange={handleChange}
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Amount Paid Till Now</label>
            <input
              type="number"
              className="form-control"
              name="amountPaidTillNow"
              value={formData.amountPaidTillNow}
              onChange={handleChange}
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Remaining 30% Amount</label>
            <input
              type="number"
              className="form-control"
              name="remainingThirtyPercentAmount"
              value={formData.remainingThirtyPercentAmount}
              onChange={handleChange}
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Payment Date</label>
            <input
              type="date"
              className="form-control"
              name="paymentDate"
              value={formData.paymentDate}
              onChange={handleChange}
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Transaction ID</label>
            <input
              type="text"
              className="form-control"
              name="txnId"
              value={formData.txnId}
              onChange={handleChange}
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Status</label>
            <select
              className="form-select"
              name="status"
              value={formData.status}
              onChange={handleChange}
              required
            >
              <option value="SUCCESS">SUCCESS</option>
              <option value="FAILED">FAILED</option>
            </select>
          </div>

          <div className="form-check mb-3">
            <input
              className="form-check-input"
              type="checkbox"
              name="eligibleForPlot"
              checked={formData.isEligibleForPlot}
              onChange={handleChange}
              id="plotEligible"
            />
            <label className="form-check-label" htmlFor="plotEligible">
              Eligible for Plot
            </label>
          </div>

          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? "Submitting..." : "Submit Transaction"}
          </button>
        </form>
      </div>
    </div>
    </Base>
  );
}
